import React from 'react';
import dopplerLogo from '../assets/doppler_logo.svg';
import sidebarOpenIcon from '../assets/sidebar_open.svg';

interface SidebarHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isOpen, onToggle }) => {
  return (
    <div className="px-4 py-4">
      <div className="flex items-center justify-between px-1 whitespace-nowrap">
        <div className="flex items-center space-x-3">
          <div className={`relative w-5 h-5 group flex-shrink-0 ${!isOpen ? "cursor-pointer" : ""}`} onClick={!isOpen ? onToggle : undefined}>
            <img
              src={dopplerLogo}
              alt="Doppler"
              className={`w-5 h-5 transition-opacity ${!isOpen ? "group-hover:opacity-0" : ""}`}
            />
            {!isOpen && (
              <img
                src={sidebarOpenIcon}
                alt="Open sidebar"
                className="w-4 h-4 absolute inset-0 m-auto opacity-0 transition-opacity group-hover:opacity-100"
              />
            )}
          </div>
          <h1
            className={`text-lg font-bold text-[#004C4B] transition-opacity duration-200 ${isOpen ? "opacity-100" : "opacity-0"}`}
          >
            Doppler
          </h1>
        </div>
        <button
          onClick={onToggle}
          className={`p-2 hover:bg-gray-100 rounded-lg transition-all duration-200 flex-shrink-0 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
          <img src={sidebarOpenIcon} alt="Close sidebar" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default SidebarHeader;
